// src/components/Home.js
import React from 'react';
import IMG from "../constants/image";
import {useNavigate} from "react-router-dom";
import Share from "../components/Share/Share";
import {isMobile} from "react-device-detect";

const SharePage = () => {
    const navigate = useNavigate()

    const onBack = () => {
        navigate(-1)
    }

    return (
        <div className='relative animate-fadeIn'>
            <div className='hidden md:flex flex-col justify-center items-center text-sm'>
                <div className='flex justify-center items-center gap-[5px] md:mb-2.5 md:pb-2.5'>
                    {isMobile && <img className='absolute left-4' src={IMG.icon.chevronLeftBlack} alt="chevronLeftBlack"
                                      onClick={onBack}/>}
                    <img className='' src={IMG.icon.shareGreen} alt="setupGreen"/>
                    <p className='text-sm md:text-xl font-bold'>Chia sẻ</p>
                </div>
            </div>
            <Share/>
        </div>
    );
}

export default SharePage;